import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Autocolor } from '../models/autocolor';
import { FormulaColor } from '../models/formulacolor';
import { ParamsPlantilla } from '../models/paramsplantilla';
import { AppConfigService } from './config/app.config.service';
import { MessageService } from './message.service';

@Injectable({ providedIn: 'root' })
export class AutocolorService {

    constructor(
        private http: HttpClient,
        private messageService: MessageService,
        private confServ: AppConfigService
    ) { }

    getFormulaColors(id: number) {
        return this.http.get<FormulaColor[]>(`${this.confServ.getConfig().apiUrlMtto}/formulas/colors/${id}/formulacolors`);
    }

    agregarFormulaColor(id: number, formulacolor: FormulaColor) {
        return this.http.post<FormulaColor>(`${this.confServ.getConfig().apiUrlMtto}/formulas/colors/${id}/formulas`, formulacolor);
    }

    buscarColores(params: ParamsPlantilla): Observable<Autocolor[]> {
        return this.http.post<Autocolor[]>(`${this.confServ.getConfig().apiUrlMtto}/formulas/colors/buscarcolores`, params);
    }

    agregarAutocolor(color: Autocolor): Observable<Autocolor> {
        return this.http.post<Autocolor>(`${this.confServ.getConfig().apiUrlMtto}/formulas/colors`, color);
    }

    actualizarAutocolor(color: Autocolor): Observable<Autocolor> {
        return this.http.put<Autocolor>(`${this.confServ.getConfig().apiUrlMtto}/formulas/colors`, color);
    }

    private log(message: string) {
        this.messageService.add(`AutocolorService: ${message}`);
    }


    /**
 * Handle Http operation that failed.
 * Let the app continue.
 * @param operation - name of the operation that failed
 * @param result - optional value to return as the observable result
 */
    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }


}